import React from 'react'

const ServerErrorPage = () => {
  return (
    <div>ServerErrorPage</div>
  )
}

export default ServerErrorPage